import { ApolloClient } from "@apollo/client"
import { useContext } from "react"
import { NeqlClientContext } from "../Context/NeqlClientContext"

export function useNeqlContextProvider(
    service: "turbine" | "measurer" | "metaAI"
): ApolloClient<any>
export function useNeqlContextProvider(
    service: "metaAIApp",
    appId: string
): ApolloClient<any>
export function useNeqlContextProvider(
    ...args: ["turbine" | "measurer" | "metaAI"] | ["metaAIApp", string]
): ApolloClient<any> {
    const map = useContext(NeqlClientContext)

    if (args[0] === "metaAIApp") {
        return map.metaAIApp(args[1])
    }

    return map[args[0]]
}
